import companyNames from 'constants/companyNames';
import FormWithEditButton from '../FormWithEditButton/FormWithEditButton';
import Input from 'tailwind-components/Input/Input';
import InputWithCopyButton from 'components/InputWithCopyButton/InputWithCopyButton';
import React from 'react';
import propTypes from 'prop-types';

function PersonalInfoForm({ user, onClick }) {
  return (
    <FormWithEditButton onClick={onClick}>
      <form
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '15%'
        }}
        action=''
      >
        <div>
          <p style={{ fontWeight: 'bold', margin: '12px 0', color: '#000' }}>
            Agent Information
          </p>
          <Input
            label='First Name:'
            placeholder='-'
            value={user.First_Name ? user.First_Name : ''}
            disabled
            autoFocus
          />
          <Input
            label='Last Name:'
            placeholder='-'
            value={user.Last_Name ? user.Last_Name : ''}
            disabled
          />
          <Input
            label={`${companyNames.short} Email:`}
            placeholder='-'
            value={user.Email ? user.Email : ''}
            disabled
          />
          <Input
            label='Phone:'
            placeholder='-'
            value={user.Phone ? user.Phone : ''}
            disabled
          />
          <InputWithCopyButton
            label='NPN:'
            placeholder='-'
            value={user.NPN ? user.NPN : ''}
            disabled
            lightLabel
            noSpacing={true}
          />
          <InputWithCopyButton
            label='FFM ID:'
            placeholder='-'
            value={user.FFMIG_Number ? user.FFMIG_Number : ''}
            disabled
            lightLabel
            noSpacing={true}
          />
        </div>
        <div>
          <p style={{ fontWeight: 'bold', margin: '12px 0', color: '#000' }}>
            Address Information
          </p>
          <Input
            label='Street:'
            placeholder='-'
            value={user.Mailing_Street || ''}
            disabled
          />
          <Input
            label='Street 2:'
            placeholder='-'
            value={user.Mailing_Street_2 || ''}
            disabled
          />
          <Input
            label='City:'
            placeholder='-'
            value={user.Mailing_City || ''}
            disabled
          />
          <Input
            label='State:'
            placeholder='-'
            value={user.Mailing_State || ''}
            disabled
          />
          <Input
            label='ZIP Code:'
            placeholder='-'
            value={user.Mailing_Zip || ''}
            disabled
          />
          <Input
            label='Country:'
            placeholder='-'
            value={user.Mailing_Country || ''}
            disabled
          />
        </div>
      </form>
    </FormWithEditButton>
  );
}

PersonalInfoForm.propTypes = {
  user: propTypes.object,
  onClick: propTypes.func
};

export default PersonalInfoForm;
